<template>
    <div class="tooltip-wrapper" ref="wrapper">
        <span class="tooltip-text" :style="tooltipPosition" v-if="active">
            {{ message }}
        </span>
        <span class="input-group tooltip-parent" :class="'align-items-' + alignment">
            <div v-if="$slots.tooltip_sibling" ref="sibling">
                <slot name="tooltip_sibling"></slot>
            </div>
            <div @mouseover="active = true" 
                @mouseleave="active = false" 
                class="d-flex align-items-center justify-content-center input-group-append"
            >
                <slot name="tooltip_trigger"></slot>
            </div>
        </span>
    </div>
</template>
<script type="text/javascript">
    export default {
        name: 'generic-tooltip',
        props: {
            alignment: {
                type: String,
                default: 'center',
                validator: function(propValue) {
                    return ['start', 'center', 'end'].indexOf(propValue) !== -1
                }
            },
            position: {
                type: String,
                default: 'top',
                validator: function(propValue) {
                    return ['top', 'bottom', 'left', 'right', 'top-no-label'].indexOf(propValue) !== -1
                }
            },
            message: {
                type: String,
                default: '',
                required: true
            }
        },
        computed: {
            wrapperHeight() {
                if (!this.isMounted) return null;


                console.log('wrapperheight', this.$refs.sibling.clientHeight);
                return this.$refs.wrapper.clientHeight;
            },
            wrapperWidth() {
                if (!this.isMounted) return null;


                console.log('wrapperwidth', this.$refs.sibling.clientHeight);
                return this.$refs.wrapper.clientWidth;
            },
            siblingHeight() {
                if (!this.isMounted) return null;


                console.log('siblingheight', this.$refs.sibling.clientHeight);
                return this.$refs.sibling.clientHeight;
            },
            tooltipPosition() {
                let style;

                switch (this.position) {
                    case 'top':
                        style = { 'bottom': (this.wrapperHeight + 10) + 'px' }
                        break;
                    case 'top-no-label':
                        style = { 'bottom': (this.siblingHeight + 10) + 'px' }
                        break;
                    case 'bottom':
                        style = { 'top': (this.wrapperHeight + 10) + 'px' }
                        break;
                    case 'left':
                        style = { 'right': (this.wrapperWidth + 10) + 'px' }
                        break;
                    case 'right':
                        style = { 'left': (this.wrapperWidth + 10) + 'px' }
                        break;
                }

                return style
            }
        },
        data() {
            return {
                active: false,
                isMounted: false
            }
        },
        mounted() {
            this.isMounted = true;
        }
    };
</script>
<style scoped lang="css">
    .tooltip-wrapper {
        position: relative;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-end;
    }

    .tooltip-wrapper label {
        display: inline-flex;
        justify-content: space-between;
    }

    .tooltip-parent {
        width: 100%;
        display: grid;
        grid-template-columns: 1fr 3rem;
    }

    .tooltip-text {
        position: absolute;
        background: white;
        box-shadow: 1px 1px 6px 3px rgba(0, 0, 0, 0.1);
        padding: 1rem 1.25rem;
        border-radius: 2px;
        border: 1px solid #dedede;
        z-index: 1040;
        max-width: 28rem;
    }

    .tooltip--right {
        left: calc(100% + 0.5rem);
    }

    .tooltip--left {
        right: calc(100% + 0.5rem);
    }

    .tooltip--top {
        bottom: calc(100% + 0.5rem);
    }

    .tooltip--bottom {
        top: calc(100% + 0.5rem);
    }

    .form-group {
        margin-bottom: 0 !important;
        margin-top: 0 !important;
    }

    .tooltip-wrapper::v-deep label {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        flex-direction: row-reverse;
    }

    .tooltip-wrapper::v-deep .required-field {
        position: relative !important;
    }

    .tooltip-wrapper >>> label {
        display: flex;
        justify-content: flex-end;
        flex-direction: row-reverse;
    }

    .tooltip-wrapper >>> .required-field {
        position: relative !important;
    }
</style>